<script setup lang="ts">
import { fetchGlobalData, fetchHomepageData, queryKey } from '~/queries'
import HomepageTemplate from '~/pages-templates/HomepageTemplate.vue'
import { useCachedAsyncData } from '~/composables/useCachedAsyncData'


const authToken = useCookie('authToken')
const { domain } = useSite().site.value
const path = '/'

const [homepageData] = await Promise.all([
  useCachedAsyncData(
    queryKey('info', domain, path),
    fetchHomepageData,
    {
      watch: [authToken],
      serverMaxAge: 7200,
      serverCacheTags: [`homepage:${domain}`],
      clientMaxAge: 7200,
    },
  ),
  useAsyncData(queryKey('global-data'), fetchGlobalData),
])

const { data } = homepageData
const siteStore = useSiteStore()

watch(
  () => data.value?.straplines,
  (straplines) => {
    if (typeof straplines !== 'undefined') {
      siteStore.setStraplines(straplines ?? null)
    }
  },
  { immediate: true },
)

const meta = computed(() => {
  const title = data.value?.page?.seoTitle || data.value?.page?.title

  const description = data.value?.page?.seoDescription

  const keywords = data.value?.page?.seoKeywords

  const image = data.value?.page?.image

  const ogImage = image ?? undefined

  const canonical = getCanonicalLink(path)

  return { title, description, keywords, ogImage, canonical }
})

useHead({
  link: [{ rel: 'canonical', href: meta.value.canonical }],
})

useSeoMeta({
  title: meta.value.title,
  description: meta.value.description,
  keywords: meta.value.keywords,
  ogDescription: meta.value.description,
  ogUrl: meta.value.canonical,
  ogImage: meta.value.ogImage,
})

useHreflang()

</script>

<template>
  <NuxtLayout>
    <AppContainer class="my-10 md:my-20">
      <HomepageTemplate :page="data?.page"/>
      <AppNewsletter />
    </AppContainer>
  </NuxtLayout>

</template>
